export const Groups = [
    {
        name: 'Content',
        label: 'Content'
    },
    {
        name: 'Input',
        label: 'Input'
    },
    {
        name: 'Data',
        label: 'Data'
    },
    {
        name: 'Charts',
        label: 'Charts'
    }
];

export const UnknownComponent = {
    id: "unknown",
    name: "Unknown",
    properties: {
        isVisible: ['Name', 'Binding', 'Content', 'Label', 'IsEditable', 'IsRequired', 'Size', 'MaxSize', 'Placeholder', 'HelpInfo', 'Width', 'Height', 'URL', 'TypeSelect', 'Columns', 'DisplayProperty', 'IsSearchable', 'IsMultiSelect'],
        isEditable: ['Name', 'Binding', 'Content', 'Label', 'IsEditable', 'IsRequired', 'Size', 'MaxSize', 'Placeholder', 'HelpInfo', 'Width', 'Height', 'URL', 'TypeSelect', 'Columns', 'DisplayProperty', 'IsSearchable', 'IsMultiSelect'],
        isRequired: ['Name']
    },
    binding: 'COMPLEX',
    docsUrl: null,
};

export const Components = [
    {
        id: 'hidden',
        name: 'Hidden',
        label: 'Hidden',
        alias: [],
        tooltip: {
            title: 'Hidden',
            content: 'Do not display anything'
        },
        properties: {
            isVisible: ['Name', 'Binding'],
            isEditable: ['Name', 'Binding'],
            isRequired: ['Name', 'Binding']
        },
        icon: 'eye-close',
        background: '#2196f3',
        group: 'Content',
        binding: 'PRIMITIVE',
        docsUrl: null,
    },
    {
        id: 'presentation',
        name: 'Presentation',
        label: 'Presentation',
        alias: [],
        tooltip: {
            title: 'Presentation',
            content: 'Display rich text content'
        },
        properties: {
            isVisible: ['Name', 'Content'],
            isEditable: ['Name', 'Content'],
            isRequired: ['Name', 'Content']
        },
        icon: 'header',
        background: '#2196f3',
        group: 'Content',
        binding: 'PRIMITIVE',
        docsUrl: null,
    },
    {
        id: 'list',
        name: 'List',
        label: 'List',
        alias: [],
        tooltip: {
            title: 'List',
            content: 'Display a list of items as a bullet or numbered list'
        },
        properties: {
            isVisible: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isEditable: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isRequired: ['TypeSelect', 'Name']
        },
        icon: 'list',
        background: '#f44336',
        group: 'Content',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'outcomes',
        name: 'Outcomes',
        label: 'Outcomes',
        alias: [],
        tooltip: {
            title: 'Outcomes',
            content: 'Display any associated Outcome buttons'
        },
        properties: {
            isVisible: ['Name', 'Label'],
            isEditable: ['Name', 'Label'],
            isRequired: ['Name']
        },
        icon: 'menu-hamburger',
        background: '#f44336',
        group: 'Content',
        bindingType: 'PRIMITIVE',
        docsUrl: null,
    },
    {
        id: 'input',
        name: 'Input',
        label: 'Input',
        alias: [],
        tooltip: {
            title: 'Input',
            content: 'Get input from the user: text, numbers, datetime & password'
        },
        properties: {
            isVisible: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Size', 'MaxSize', 'Binding', 'Placeholder', 'HelpInfo'],
            isEditable: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Size', 'MaxSize', 'Binding', 'Placeholder', 'HelpInfo'],
            isRequired: ['Name', 'Size', 'MaxSize', 'Binding']
        },
        icon: 'italic',
        background: '#3f51b5',
        group: 'Input',
        bindingType: 'PRIMITIVE',
        docsUrl: null,
    },
    {
        id: 'image',
        name: 'Image',
        label: 'Image',
        alias: [],
        tooltip: {
            title: 'Image',
            content: 'Display an image'
        },
        properties: {
            isVisible: ['Name', 'Label', 'URL', 'Width', 'Height'],
            isEditable: ['Name', 'Label', 'URL', 'Width', 'Height'],
            isRequired: ['Name', 'URL', 'Width', 'Height']
        },
        icon: 'picture',
        background: '#ffb300',
        group: 'Content',
        docsUrl: null,
    },
    {
        id: 'radio',
        name: 'Radio',
        label: 'Radio',
        alias: [],
        tooltip: {
            title: 'Radio',
            content: 'Mutually exclusive option selection'
        },
        properties: {
            isVisible: ['TypeSelect', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'Columns', 'Binding', 'HelpInfo'],
            isEditable: ['TypeSelect', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'Columns', 'Binding', 'HelpInfo'],
            isRequired: ['TypeSelect', 'Name', 'Binding']
        },
        icon: 'option-vertical',
        background: '#4caf50',
        group: 'Input',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'checkbox',
        name: 'Checkbox',
        label: 'Checkbox',
        alias: [],
        tooltip: {
            title: 'Checkbox',
            content: 'True or False option selection'
        },
        properties: {
            isVisible: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Binding', 'HelpInfo'],
            isEditable: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Binding', 'HelpInfo'],
            isRequired: ['Name', 'Binding']
        },
        icon: 'check',
        background: '#00897b',
        group: 'Input',
        bindingType: 'PRIMITIVE',
        docsUrl: null,
    },
    {
        id: 'toggle',
        name: 'Toggle',
        label: 'Toggle',
        alias: [],
        tooltip: {
            title: 'Toggle',
            content: 'True or False option selection, larger than a checkbox for touch devices'
        },
        properties: {
            isVisible: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Binding', 'HelpInfo'],
            isEditable: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Binding', 'HelpInfo'],
            isRequired: ['Name', 'Binding']
        },
        icon: 'sound-stereo',
        background: '#00897b',
        group: 'Input',
        bindingType: 'PRIMITIVE',
        docsUrl: null,
    },
    {
        id: 'textarea',
        name: 'Text',
        label: 'Text',
        alias: [],
        tooltip: {
            title: 'Text',
            content: 'Get multiline text input from the user'
        },
        properties: {
            isVisible: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Width', 'Height', 'MaxSize', 'Binding', 'Placeholder', 'HelpInfo'],
            isEditable: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Width', 'Height', 'MaxSize', 'Binding', 'Placeholder', 'HelpInfo'],
            isRequired: ['Name', 'Width', 'Height', 'MaxSize', 'Binding']
        },
        icon: 'edit',
        background: '#5B0C69',
        group: 'Input',
        bindingType: 'PRIMITIVE',
        docsUrl: null,
    },
    {
        id: 'content',
        name: 'Rich Text',
        label: 'Rich Text',
        alias: [],
        tooltip: {
            title: 'Rich Text',
            content: 'Get rich text input from the user'
        },
        properties: {
            isVisible: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Width', 'Height', 'MaxSize', 'Binding', 'Placeholder', 'HelpInfo'],
            isEditable: ['Name', 'Label', 'IsEditable', 'IsRequired', 'Width', 'Height', 'MaxSize', 'Binding', 'Placeholder', 'HelpInfo'],
            isRequired: ['Name', 'Width', 'Height', 'MaxSize', 'Binding']
        },
        icon: 'text-size',
        background: '#9c27b0',
        group: 'Input',
        bindingType: 'PRIMITIVE',
        docsUrl: null,
    },
    {
        id: 'file-upload',
        name: 'File Upload',
        label: 'File Upload',
        alias: ['file_upload'],
        tooltip: {
            title: 'File Upload',
            content: 'Allows users to upload file(s)'
        },
        properties: {
            isVisible: ['Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'Files', 'Binding', 'HelpInfo', 'Placeholder'],
            isEditable: ['Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'Files', 'Binding', 'HelpInfo', 'Placeholder'],
            isRequired: ['Name']
        },
        icon: 'open-file',
        background: '#133854',
        group: 'Data',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'table',
        name: 'Table',
        label: 'Table',
        alias: ['files'],
        tooltip: {
            title: 'Table',
            content: 'Display a list of items in a table'
        },
        properties: {
            isVisible: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'IsSearchable', 'Binding', 'Columns'],
            isEditable: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'IsSearchable', 'Binding', 'Columns'],
            isRequired: ['TypeSelect', 'Name']
        },
        icon: 'th',
        background: '#f44336',
        group: 'Data',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'files',
        name: 'Files',
        label: 'Files',
        alias: [],
        tooltip: {
            title: 'Files',
            content: 'Display a list of Files in a table with download links'
        },
        properties: {
            isVisible: ['Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'IsSearchable', 'Files', 'Columns', 'Binding'],
            isEditable: ['Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'IsSearchable', 'Files', 'Columns', 'Binding'],
            isRequired: ['Name']
        },
        icon: 'file',
        background: '#f44336',
        group: 'Data',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'tiles',
        name: 'Tiles',
        label: 'Tiles',
        alias: [],
        tooltip: {
            title: 'Tiles',
            content: 'Display a list of items as a series of Tiles'
        },
        properties: {
            isVisible: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'IsSearchable', 'Binding', 'Columns'],
            isEditable: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'IsSearchable', 'Binding', 'Columns'],
            isRequired: ['TypeSelect', 'Name']
        },
        icon: 'th-large',
        background: '#f44336',
        group: 'Data',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'select',
        name: 'Combobox',
        label: 'Combobox',
        alias: [],
        tooltip: {
            title: 'Combobox',
            content: 'Select one or more items from a list'
        },
        properties: {
            isVisible: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'Columns', 'Width', 'HelpInfo'],
            isEditable: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'Columns', 'Width', 'HelpInfo'],
            isRequired: ['TypeSelect', 'Binding', 'Name']
        },
        icon: 'collapse-down',
        background: '#607d8b',
        group: 'Input',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'value_selector',
        name: 'ValueSelector',
        label: 'Value Selector',
        alias: [],
        tooltip: {
            title: 'Value Selector',
            content: 'Select an existing value or create a new one'
        },
        properties: {
            isVisible: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'DisplayProperty', 'Binding'],
            isEditable: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'DisplayProperty', 'Binding'],
            isRequired: ['TypeSelect', 'Binding', 'Name', 'DisplayProperty', 'Binding']
        },
        icon: 'collapse-down',
        background: '#607d8b',
        tenant: '1ceee612-565f-4910-9b07-e94bf605c3ba',
        group: 'Input',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'shared_element_selector',
        name: 'SharedElementSelector',
        label: 'Shared Element Selector',
        alias: [],
        tooltip: {
            title: 'Shared Element Selector',
            content: 'Select an existing shared element'
        },
        properties: {
            isVisible: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'DisplayProperty', 'Binding'],
            isEditable: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'DisplayProperty', 'Binding'],
            isRequired: ['TypeSelect', 'Binding', 'Name', 'DisplayProperty', 'Binding']
        },
        icon: 'collapse-down',
        background: '#607d8b',
        tenant: '1ceee612-565f-4910-9b07-e94bf605c3ba',
        group: 'Input',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'value_selector_table',
        name: 'ValueSelectorTable',
        label: 'Value Selector Table',
        alias: [],
        tooltip: {
            title: 'Value Selector',
            content: 'Select an existing value or create a new one'
        },
        properties: {
            isVisible: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'DisplayProperty', 'Binding'],
            isEditable: ['TypeSelect', 'Binding', 'Name', 'Label', 'IsMultiSelect', 'IsEditable', 'IsRequired', 'DisplayProperty', 'Binding'],
            isRequired: ['TypeSelect', 'Binding', 'Name', 'DisplayProperty', 'Binding']
        },
        icon: 'collapse-down',
        background: '#607d8b',
        tenant: '1ceee612-565f-4910-9b07-e94bf605c3ba',
        group: 'Input',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'form',
        name: 'Form',
        label: 'Form',
        alias: [],
        tooltip: {
            title: 'Form',
            content: 'Edit objects & lists'
        },
        properties: {
            isVisible: ['Binding', 'Name', 'Label', 'IsRequired'],
            isEditable: ['Binding', 'Name', 'Label', 'IsRequired'],
            isRequired: ['Binding', 'Name']
        },
        icon: 'collapse-down',
        background: '#607d8b',
        tenant: '1ceee612-565f-4910-9b07-e94bf605c3ba',
        group: 'Input',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'default_objectdata_editor',
        name: 'Default ObjectData Editor',
        label: 'Default ObjectData Editor',
        alias: [],
        tooltip: {
            title: 'Default ObjectData Editor',
            content: 'Edit objects & lists'
        },
        properties: {
            isVisible: ['Binding', 'Name', 'Label', 'IsRequired'],
            isEditable: ['Binding', 'Name', 'Label', 'IsRequired'],
            isRequired: ['Binding', 'Name']
        },
        icon: 'collapse-down',
        background: '#607d8b',
        tenant: '1ceee612-565f-4910-9b07-e94bf605c3ba',
        group: 'Input',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'chart-bar',
        name: 'Bar',
        label: 'Bar',
        alias: [],
        tooltip: {
            title: 'Bar Chart',
            content: 'Display a Bar chart'
        },
        properties: {
            isVisible: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isEditable: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isRequired: ['TypeSelect', 'Name']
        },
        icon: 'signal',
        background: '#f44336',
        group: 'Charts',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'chart-line',
        name: 'Line',
        label: 'Line',
        alias: [],
        tooltip: {
            title: 'Line Chart',
            content: 'Display a line chart'
        },
        properties: {
            isVisible: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isEditable: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isRequired: ['TypeSelect', 'Name']
        },
        icon: 'signal',
        background: '#f44336',
        group: 'Charts',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'chart-pie',
        name: 'Pie',
        label: 'Pie',
        alias: [],
        tooltip: {
            title: 'Pie Chart',
            content: 'Display a pie chart'
        },
        properties: {
            isVisible: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isEditable: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isRequired: ['TypeSelect', 'Name']
        },
        icon: 'signal',
        background: '#f44336',
        group: 'Charts',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'chart-doughnut',
        name: 'Doughnut',
        label: 'Doughnut',
        alias: [],
        tooltip: {
            title: 'Doughnut Chart',
            content: 'Display a doughnut chart'
        },
        properties: {
            isVisible: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isEditable: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isRequired: ['TypeSelect', 'Name']
        },
        icon: 'signal',
        background: '#f44336',
        group: 'Charts',
        bindingType: 'COMPLEX',
        docsUrl: null,
    },
    {
        id: 'chart-polar',
        name: 'Polar Area',
        label: 'Polar Area',
        alias: [],
        tooltip: {
            title: 'Polar Area Chart',
            content: 'Display a polar area chart'
        },
        properties: {
            isVisible: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isEditable: ['TypeSelect', 'Name', 'Label', 'Columns'],
            isRequired: ['TypeSelect', 'Name']
        },
        icon: 'signal',
        background: '#f44336',
        group: 'Charts',
        bindingType: 'COMPLEX',
        docsUrl: null,
    }
];
